import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const TaxManagement = lazy(() => import('../Compliance/TaxManagement'));
const GovernanceCenter = lazy(() => import('../Compliance/GovernanceCenter'));
const ExpensePolicySettings = lazy(() => import('../Compliance/ExpensePolicySettings'));
const ApprovalDefinitions = lazy(() => import('../Compliance/ApprovalDefinitions'));
const WorkflowOverrideBuilder = lazy(() => import('../Compliance/WorkflowOverrideBuilder'));
const RevenuePolicySettings = lazy(() => import('../Compliance/RevenuePolicySettings'));
const HMRCMTD = lazy(() => import('../Compliance/HMRCMTD'));
const UKStatutoryAccounts = lazy(() => import('../Compliance/UKStatutoryAccounts'));
const ApprovalsWorkbench = lazy(() => import('../Compliance/ApprovalsWorkbench'));
const NotificationsApprovals = lazy(() => import('../Compliance/NotificationsApprovals'));
const AuditLogViewer = lazy(() => import('../Compliance/AuditLogViewer'));
const AuditTrailInspector = lazy(() => import('../Compliance/AuditTrailInspector'));
const ActivityLogs = lazy(() => import('../Compliance/ActivityLogs'));

const Users = lazy(() => import('../Admin/Users'));
const Roles = lazy(() => import('../Admin/Roles'));

const Settings = lazy(() => import('../Admin/Settings'));
const CompanyManagement = lazy(() => import('../Admin/CompanyManagement'));
const CurrencyManagement = lazy(() => import('../Admin/CurrencyManagement'));
const ApiSettings = lazy(() => import('../Admin/ApiSettings'));
const DataImport = lazy(() => import('../Admin/DataImport'));
const Notifications = lazy(() => import('../Admin/Notifications'));
const ManageSubscription = lazy(() => import('../Admin/ManageSubscription'));
const SubscriptionSettings = lazy(() => import('../Admin/SubscriptionSettings'));
const BillingHistory = lazy(() => import('../Admin/BillingHistory'));
const SecuritySettings = lazy(() => import('./SecuritySettings'));

export const settingsRoutes = (
    <React.Fragment key="settings">
        {/* COMPLIANCE & AUDIT */}
        <Route element={<ProtectedRoute permission="admin.tax.view" />}>
            <Route path="/tax-management" element={<TaxManagement />} />
        </Route>
        <Route element={<ProtectedRoute permission="admin.settings.manage" />}>
            <Route path="/tax-governance" element={<GovernanceCenter />} />
            <Route path="/financial-policies" element={<ExpensePolicySettings />} />
            <Route path="/approval-definitions" element={<ApprovalDefinitions />} />
            <Route path="/workflows/overrides" element={<WorkflowOverrideBuilder />} />
            <Route path="/revenue-recognition" element={<RevenuePolicySettings />} />
            <Route path="/hmrc-mtd" element={<HMRCMTD />} />
            <Route path="/uk-statutory" element={<UKStatutoryAccounts />} />
        </Route>
        {/* WORKFLOW APPROVALS & NOTIFICATIONS CENTER (Filtered by RBAC & RBSC) */}
        <Route path="/workflow/approvals" element={<ApprovalsWorkbench />} />
        <Route path="/notifications-approvals" element={<NotificationsApprovals />} />

        <Route element={<ProtectedRoute permission="admin.audit.view" />}>
            <Route path="/audit-log" element={<AuditLogViewer />} />
            <Route path="/audit-trail-inspector" element={<AuditTrailInspector />} />
            <Route path="/activity-logs" element={<ActivityLogs />} />
        </Route>

        {/* ADMINISTRATION */}
        <Route element={<ProtectedRoute permission="admin.user.view" />}>
            <Route path="/users" element={<Users />} />
            <Route path="/roles" element={<Roles />} />
        </Route>
        <Route element={<ProtectedRoute permission="admin.settings.manage" />}>
            <Route path="/settings" element={<Settings />} />
            <Route path="/companies" element={<CompanyManagement />} />
            <Route path="/currencies" element={<CurrencyManagement />} />
            <Route path="/api-access" element={<ApiSettings />} />
            <Route path="/data-import" element={<DataImport />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/subscription" element={<ManageSubscription />} />
            <Route path="/subscription-settings" element={<SubscriptionSettings />} />
            <Route path="/billing-history" element={<BillingHistory />} />
            <Route path="/security-settings" element={<SecuritySettings />} />
        </Route>
    </React.Fragment>
);
